import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const ServiceLayout = ({ breadcrumbs = [], title, subtitle, children, titleStyle }) => {
    const { t } = useTranslation()

    return (
        <div className="pt-24 sm:pt-28 pb-24 px-4 sm:px-6 overflow-x-hidden">
            <div className="max-w-6xl mx-auto">
                {breadcrumbs.length > 0 && (
                    <motion.nav className="flex items-center gap-1.5 text-xs mb-8 flex-wrap" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                        {breadcrumbs.map((crumb, i) => (
                            <React.Fragment key={i}>
                                {i > 0 && <ChevronRight className="w-3 h-3 text-text-dim/40" />}
                                {crumb.path ? <Link to={crumb.path} className="text-text-dim hover:text-primary transition-colors">{crumb.label}</Link>
                                    : <span className="text-text-main font-medium">{crumb.label}</span>}
                            </React.Fragment>
                        ))}
                    </motion.nav>
                )}

                <motion.div className="flex-1 min-w-0" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
                    <h1 className="text-3xl sm:text-4xl font-display font-bold tracking-tight text-text-main mb-4" style={titleStyle}>
                        {title === 'Predictive, Diagnostic & Prognostic Biomarker Discovery' ? (
                            <>Predictive, Diagnostic &amp;<br />Prognostic Biomarker Discovery</>
                        ) : title}
                    </h1>
                    {subtitle && <p className="text-text-muted text-base leading-relaxed mb-10">{subtitle}</p>}
                    {children}
                </motion.div>
            </div>
        </div>
    )
}

export default ServiceLayout
